import { RouteObject } from "react-router-dom";
import { LoginPage } from "./pages/login-page";

const routes: RouteObject[] = [
  { path: "login", element: <LoginPage /> },
];

export default routes;
